import { Box } from '@ksyos/design-system';
import { styled } from 'styled-components';

export const StyledGroupMeetingBox = styled(Box)`
    cursor: pointer;
    width: 231px;
    min-height: 140px;
    padding: 32px;
    background: #fff;
    box-shadow: 0 8px 12px -4px rgb(219 213 208 / 30%);
    border: 1px solid #faf9f8;
    border-radius: 4px;
    padding-top: 10px;
    padding-bottom: 12px;
`;

export const FinishedMdoStyledBox = styled(Box)`
    background: #fffb;
    z-index: 1;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
